import React, { useEffect, useState } from 'react';

import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './BookingGeneral.scss';
import Field from '../../../Shared/Wizard/Field/Field';
import { InputGroup, Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import CreateCustomerModal from '../../../Shared/Modals/Create/CreateCustomerModal';
import EditCustomerModal from '../../../Shared/Modals/Edit/EditCustomerModal';

import moment from 'moment';

function BookingGeneral(props) {
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const [totalNights, setTotalNights] = useState(0);
    const myRef = React.createRef<Typeahead<any>>();

    const auth = useAuth();
    const [updateTable, setUpdateTable] = useState(0);
    const [getCustomer, setGetCustomer] = useState("");

    const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
    const [showEditCustomerModal, setShowEditCustomerModal] = useState(false);
    const handleShowCreateCustomerModal = () => { setShowCreateCustomerModal(true); };
    const handleShowEditCustomerModal = () => { setShowEditCustomerModal(true); };

    const [selectedCustomer, setSelectedCustomer] = useState<Array<any>>([]);

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const handleOnChangeArrivalDate= (date) => {
        let tempBooking = props.booking;
        
        if (tempBooking.departuredate != undefined && tempBooking.departuredate != null) {
            if(new Date(date).getTime() >= new Date(tempBooking.departuredate).getTime()){
                notifyWarning(t("booking.general.toast_arrivaldate_invalid")); return undefined; 
            }
        }

        tempBooking["arrivaldate"] = date;
        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }

        localStorage.setItem("editedItems", "true");
    }

    const handleOnChangeDepartureDate= (date) => {
        let tempBooking = props.booking;

        if (tempBooking.arrivaldate != undefined && tempBooking.arrivaldate != null) {
            if(new Date(date).getTime() <= new Date(tempBooking.arrivaldate).getTime()){
                notifyWarning(t("booking.general.toast_departuredate_invalid")); return undefined; 
            }
        }
        
        tempBooking["departuredate"] = date;
        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }

        localStorage.setItem("editedItems", "true");
    }

    function getPriceAndUnit(resource, selectedDeal) {
        let output = {unit: "", price: ""};

        function getPriceByUnit(priceList, unit) {
            if (unit == "") {
                return priceList[0].price;
            } else {
                return priceList.find(p => p.unit == unit)?.price ?? priceList[0].price;
            }
        }
        let exactPrices: Array<any> = [];
        let subcatPrices: Array<any> = [];
        let catPrices: Array<any> = [];

        if (selectedDeal != undefined) {
            exactPrices = selectedDeal["priceList"].filter(i => i.resource == resource.resource);
            subcatPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == resource.resourceSubtype && i.resource == "");
            catPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == "");
        }

        if (exactPrices.length > 0) {
                output.price = getPriceByUnit(exactPrices, resource.unit);
                output.unit = exactPrices[0].unit;
        } else if (subcatPrices.length > 0) {
                output.price = getPriceByUnit(subcatPrices, resource.unit);
                output.unit = subcatPrices[0].unit;
        } else if (catPrices.length > 0) {
                output.price = getPriceByUnit(catPrices, resource.unit);
                output.unit = catPrices[0].unit;
        } else {
            let defaultDeal = props.allDeals.find(item => item.isDefaultDeal != false);

            let exactPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resource == resource.resource);
            let subcatPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == resource.resourceSubtype && i.resource == "");
            let catPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == "");
            
            if (exactPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(exactPricesDefaultDeal, resource.unit);
                output.unit = exactPricesDefaultDeal[0].unit;
            } else if (subcatPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(subcatPricesDefaultDeal, resource.unit);
                output.unit = subcatPricesDefaultDeal[0].unit;
            } else if (catPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(catPricesDefaultDeal, resource.unit);
                output.unit = catPricesDefaultDeal[0].unit;
            }
        }

        return output;
    }

    const calculateNumberOfNights = (arrival, departure) =>{
        if(
            arrival != null &&
            arrival != undefined &&
            arrival != "" &&
            departure != null &&
            departure != undefined &&
            departure != ""
        ){
            let tmpArrival = new Date(arrival);
            let tmpDeparture = new Date(departure);
            let timeDiff = Math.abs(tmpDeparture.getTime() - tmpArrival.getTime());
            return Math.ceil(timeDiff / (1000 * 3600 * 24)); 
        } else {
            return 0;
        }
    }

    function handleOnChangeDeal(val) {
        let tempBooking = props.booking;
        let deal = (props.allDeals != undefined ? (props.allDeals.find(item => item["_id"] == val.value)) : "");
        
        if (deal != undefined) {
            tempBooking["deal"] = deal;
            tempBooking["resources"] = tempBooking["resources"]?.map(item => {
                let priceAndUnit = getPriceAndUnit(item, deal);
                return {
                    ...item,
                    unit: priceAndUnit.unit,
                    price: priceAndUnit.price
                }
            });
            if (props.onChange != undefined) {
                props.onChange(tempBooking);
            }
            localStorage.setItem("editedItems", "true");
        }
    }

    function handleOnChangeEvents(val) {
        let tempBooking = props.booking;
        let events = (props.allEvents != undefined ? (props.allEvents.filter(item => val.map(i => i.value).includes(item["_id"]))) : []);
        if (events != undefined) {
            tempBooking["events"] = events;
            if (props.onChange != undefined) {
                props.onChange(tempBooking);
            }
            localStorage.setItem("editedItems", "true");
        }
    }

    function handleChange(val, field) {
        setUpdateTable(updateTable + 1);
        let tempBooking = props.booking;
        tempBooking[field] = val;
        if (props.onChange != undefined) {
            props.onChange(tempBooking);
        }
        localStorage.setItem("editedItems", "true");
    }

    function handleChangeOrganization(value) {
        let tempBooking = props.booking;
        if(value != undefined) {
            tempBooking["customerId"] = value;
        }
        
        if (props.onChange != undefined) props.onChange(tempBooking);
        localStorage.setItem("editedItems", "true");
    }

    function getCustomerOrganization() {
        axios.get('/api/customers/' + props.booking.customerId,
        {
            id: props.booking.customerId,
        }, {
            headers: {'x-access-token': auth.user["token"]}
        }).then(function(res){
            setGetCustomer(res.data);         
        });
    }

    useEffect(() => {
        setTotalNights(calculateNumberOfNights(props.booking.arrivaldate, props.booking.departuredate)); //for editing
        
    }, [props.booking]);

    useEffect(() => {
        if(props.booking != undefined && props.booking.customerId != undefined){
            getCustomerOrganization();
        }
    }, [props.booking.customerId]);

    return (
        <div style={{ marginTop: '20px' }}>
            <h3>{t("booking.general.title_bookinginformation")}</h3>
            <Field
                type="input"
                title={t("booking.bookingnumber")}
                value={props.booking.bookingnumber != undefined ? props.booking.bookingnumber : ""}
                disabled={true}
            ></Field>
            <Field
                type="input"
                title={t("booking.general.invoice_title")}
                value={props.booking.invoiceTitle != undefined ? props.booking.invoiceTitle : undefined}
                onChange={value => handleChange(value, "invoiceTitle")}
            ></Field>
            <Field
                type="input"
                title={t("booking.general.external_reference")}
                value={props.booking.externalReference != undefined ? props.booking.externalReference : undefined}
                onChange={value => handleChange(value, "externalReference")}
            ></Field>
            <Field
                type="select"
                title={t("booking.general.deal")}
                value={props.booking.deal != undefined ? { label: "", value: props.booking.deal._id } : undefined}
                defaultValue={props.allDeals != undefined ? {label: ((props.allDeals.find(i => i["isDefaultDeal"] == true) || { name: "" }) as any)["name"], value: ((props.allDeals.find(i => i["isDefaultDeal"] == true) || { _id: "" }) as any)["_id"]}  : ""}
                onChange={value => handleOnChangeDeal(value)}
                options={{
                    choosetext: t("booking.general.deal_choosetext"),
                    choices: props.allDeals != undefined ? props.allDeals.map((option, key) => { return {label: option["name"], value: option["_id"]}}) : ""
                }}
            ></Field>
            <Field
                type="selectmulti"
                title={t("booking.general.events")}
                defaultValue={props.booking.events != undefined ? props.booking.events.map(i => {return { label: i.name, value: i._id }}) : []}
                onChange={value => handleOnChangeEvents(value)}
                options={{
                    choosetext: t("booking.general.events_choosetext"),
                    choices: props.allEvents.length > 0 ? props.allEvents.map((option, key) => { return {label: option["name"], value: option["_id"]}}) : []
                }}
            ></Field>
            <Field
                type="input"
                title={t("booking.general.numberofpeople")}
                value={props.booking["guests"] != undefined ? props.booking["guests"].length : ""}
                disabled
            ></Field>
            <div className="row" style={{width: "100%"}} >
                <div className="col col-sm-4">
                    <Field
                        type="dateselector"
                        title={t("booking.general.arrivaldate")}
                        onChange={(date) => { handleOnChangeArrivalDate(date); }}
                        value={props.booking.arrivaldate != undefined && props.booking.arrivaldate != null ? 
                            new Date(props.booking.arrivaldate) : props.booking.events != undefined && props.booking.events.length > 0 ?
                            props.booking.arrivaldate = props.booking.events[0].periods[0].from: undefined}
                        dateFormat="dd.MM.yyyy"
                        startDate={props.booking.arrivaldate != undefined && props.booking.arrivaldate != null ? new Date(props.booking.arrivaldate) : undefined}
                        endDate={props.booking.departuredate != undefined && props.booking.departuredate != null ? new Date(props.booking.departuredate) : undefined}
                        selectsStart
                        //min={moment().add(-2, 'days').toDate()}
                    ></Field>
                </div>
                <div className="col col-sm-4">
                    <Field
                        type="dateselector"
                        title={t("booking.general.departuredate")}
                        onChange={(date) => { handleOnChangeDepartureDate(date); }}
                        value={props.booking.departuredate != undefined && props.booking.departuredate != null ? 
                            new Date(props.booking.departuredate) : props.booking.events != undefined && props.booking.events.length > 0  ? 
                            props.booking.departuredate = props.booking.events[0].periods[0].to : undefined}
                        dateFormat="dd.MM.yyyy"
                        startDate={props.booking.arrivaldate != undefined && props.booking.arrivaldate != null ? new Date(props.booking.arrivaldate) : undefined}
                        endDate={props.booking.departuredate != undefined && props.booking.departuredate != null ? new Date(props.booking.departuredate) : undefined}
                        selectsEnd
                        //min={moment().add(-2, 'days').toDate()}
                    ></Field>
                </div>
                <div className="col col-sm-4">
                    <Field
                        type="input"
                        title={t("booking.general.nights")}
                        value={isNaN(totalNights) ? 0 : totalNights}
                        disabled={true}
                    ></Field>
                </div>
            </div>
            <Field
                type="textarea"
                title={t("booking.general.description")}
                value={props.booking.description != undefined ? props.booking.description : ""}
                onChange={value => handleChange(value, "description")}
            ></Field>
            <hr />

            <InputGroup className="mb-3">
                <InputGroup.Prepend>
                    <InputGroup.Text>{t("booking.general.select_customer")}</InputGroup.Text>
                </InputGroup.Prepend>
                <Typeahead
                    id="newOrganizationInput"
                    key={props.booking.customerId}
                    className="typeaheadinput"
                    onChange={items => {
                        if (items.length > 0) {
                            handleChangeOrganization(items[0]["id"]);
                            handleChange(items[0]["data"]["organizationName"], "organizationName");
                            setSelectedCustomer([{ id: items[0].data._id, label: items[0].data.companyRegistrationId != undefined && items[0].data.companyRegistrationId != "" ? 
                                items[0].data.organizationName : (items[0].data.lastname + ", " + items[0].data.firstname), data: items[0].data }]);
                        } else return null;
                    }}
                    placeholder={getCustomer != "" ? (getCustomer["companyRegistrationId"] != undefined && getCustomer["companyRegistrationId"] != "" ? getCustomer["organizationName"] : (getCustomer["lastname"] + ", " + getCustomer["firstname"])) : t("booking.general.search_customer")}
                    ref={myRef}
                    minLength={2}
                    emptyLabel={t("person.no_results")}
                    options={props.customers.map(c => { return { id: c._id, label: c.companyRegistrationId != undefined && c.companyRegistrationId != "" ? c.organizationName : (c.lastname + ", " + c.firstname), data: c } })} 
                    autoFocus={false}
                    selected={selectedCustomer}
                />
            </InputGroup>
            
            <Button onClick={handleShowCreateCustomerModal}>{t("booking.general.create_customer")}</Button>
            <br /> <br />
            {props.booking.customerId != undefined ? 
                <Button onClick={handleShowEditCustomerModal}>{t("booking.general.edit_customer")}</Button>
            : null}

            <CreateCustomerModal
                show={showCreateCustomerModal}
                onCancel={() => setShowCreateCustomerModal(false)}
                onHide={() => setShowCreateCustomerModal(false)}
                onSaveNew={(data) => {
                    props.onUpdateCustomer();
                    handleChangeOrganization(data._id);
                    handleChange(data.organizationName, "organizationName");
                    setSelectedCustomer([{ id: data._id, label: data.companyRegistrationId != undefined && data.companyRegistrationId != "" ? 
                        data.organizationName : (data.lastname + ", " + data.firstname), data: data }]);
                    setShowCreateCustomerModal(false); 
                }}
            ></CreateCustomerModal>

            <EditCustomerModal
                customerId={props.booking.customerId}
                show={showEditCustomerModal}
                onCancel={() => setShowEditCustomerModal(false)}
                onHide={() => setShowEditCustomerModal(false)}
                onSave={() => {
                    setShowEditCustomerModal(false); 
                }}
            ></EditCustomerModal>
            
        </div>
    );
}

export default BookingGeneral;